import { apiUtils } from "@/utils/apiUtils";
import Utils from "@/utils/utils";

export const ssoService = {
  /**
   * Get OpenID Redirect URL for SSO login (PKCE supported)
   * @param {Object} options
   * @param {string} options.codeChallenge - PKCE code_challenge (required)
   * @param {string} [options.codeChallengeMethod="S256"] - PKCE code_challenge_method (default S256)
   * @param {string|number} [options.shopCode] - Optional shop code
   */
  async getOpenIDRedirectUrl({ codeChallenge, codeChallengeMethod = "S256", shopCode } = {}) {
    try {
      return await apiUtils.doGet('/TCPGetOpenIDRedirectJ.action', {
        code_challenge: codeChallenge,
        code_challenge_method: codeChallengeMethod,
        ...(shopCode ? { shopCode } : {})
      });
    } catch (error) {
      console.error("Error on customer sso login:", error);
      throw error;
    }
  },
  async loginWithAuthorizationCode(code, state, codeVerifier) {
    try {
      const result = await apiUtils.doPost('/TCPLoginWithJWTJ.action', {
        code: !Utils.isEmpty(code) ? code : undefined,
        state: !Utils.isEmpty(state) ? state : undefined,
        codeVerifier: !Utils.isEmpty(codeVerifier) ? codeVerifier : undefined,
        returnCustomerData: "true",
      });

      return result;
    } catch (error) {
      console.error("Error on customer sso login:", error);
      throw error;
    }
  },
  async loginWithJWT(jwt, shopCode, validationType, oneTimeToken) {
    try {
      const result = await apiUtils.doPost('/TCPLoginWithJWTJ.action', {
        jwt: jwt,
        shopCode: !Utils.isEmpty(shopCode) ? shopCode : undefined,
        validationType: !Utils.isEmpty(validationType) ? validationType : undefined,
        ott: !Utils.isEmpty(oneTimeToken) ? oneTimeToken : undefined,
        returnCustomerData: "true",
      });

      return result;
    } catch (error) {
      console.error("Error on customer sso login:", error);
      throw error;
    }
  },
};
